import { render, staticRenderFns } from "./TrafficMessageForm.vue?vue&type=template&id=4561ec02"
import script from "./TrafficMessageForm.vue?vue&type=script&lang=js"
export * from "./TrafficMessageForm.vue?vue&type=script&lang=js"
import style0 from "./TrafficMessageForm.vue?vue&type=style&index=0&id=4561ec02&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports